import { BaseListFilter } from '../../../models/base-list-filter.model';

export class PricingPolicyRulesFilter extends BaseListFilter {
  partnerId?: number;
  partnerName?: string;
}
